<div class="modal-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2>{{ data.source.name }}</h2>
  </div>

  <!-- Modal Content -->
  <div class="modal-content">
    <div class="preview-container">
      <!-- PDF Viewer for file content -->
      @if (data.source.fileLink || data.source.fileUrl) {
        <div class="pdf-content">
          <app-pdf-viewer
            [fileUrl]="data.source.fileLink || data.source.fileUrl"
            [fileName]="data.source.originalFileName || data.source.name"
            [showMinimalToolbar]="true"
            >
          </app-pdf-viewer>
        </div>
      }

      <!-- Fallback to text content if no file -->
      @if (!data.source.fileLink && !data.source.fileUrl && data.source.content) {
        <div
          class="text-content"
          >
          <pre>{{ data.source.content }}</pre>
        </div>
      }

      <!-- No content state -->
      @if (!data.source.fileLink && !data.source.fileUrl && !data.source.content) {
        <div
          class="no-content"
          >
          <mat-icon>description</mat-icon>
          <p>No content available for preview</p>
        </div>
      }
    </div>
  </div>

  <!-- Bottom Footer -->
  <div class="modal-footer">
    <div class="footer-actions">
      <!-- File Info - Left Side -->
      @if (data.source.fileLink || data.source.fileUrl) {
        <div class="file-info">
          <mat-icon style="color: #1976d2; margin-right: 8px; font-size: 16px">description</mat-icon>
          <span style="color: #1976d2; font-size: 12px">
            <strong>File Preview</strong>
            <span style="margin-left: 8px; font-size: 11px; opacity: 0.8">
              {{ data.source.originalFileName || data.source.fileLink || data.source.fileUrl }}
            </span>
          </span>
        </div>
      }

      <!-- Action Buttons - Right Side -->
      <div class="action-buttons">
        <button mat-button (click)="close()" class="close-btn">Close</button>
      </div>
    </div>
  </div>
</div>
